module.exports = __webpack_public_path__ + "static/media/radio-waves-radio.a5de94e6.svg";